import gql from 'graphql-tag'

export const parklioBookingBarrierOverrideMutation = gql`
	mutation parklioBookingBarrierOverride (
		$bookingId: ID!
		$action: BollardAction!
		$reason: OverrideReason
	) {
		parklioBookingBarrierOverride(
			bookingId: $bookingId
			action: $action
			reason: $reason
		) {
			outcome
			bayLabel
		}
	}
`

export const createBookingMutation = gql`
	mutation createBooking (
		$installationId: ID!
		$rateCardId: ID!
		$plate: String!
		$staffName: String
		$reason: String
		$startDay: String
		$endDay: String

		$entryEventId: ID

		$guestName: String
		$guestEmail: String
		$guestCompany: String
		$guestDepartment: String
		$guestPhone: String
		$guestRoom: String
		$guestApartmentNumber: String
		$guestReservation: String
		$guestEmployeeCode: String
		$guestPosition: String
		$stripeCustomerId: String
		$payLater: Boolean
		$carType: String
		$carNotes: String
		$bayId: ID
		$isVip: Boolean
		$vipContactIds: [ID!]
	) {
		createBooking(
			booking: {
				installationId: $installationId
				rateCardId: $rateCardId
				plate: $plate
				staffName: $staffName
				reason: $reason
				startDay: $startDay
				endDay: $endDay

				entryEventId: $entryEventId

				guestName: $guestName
				guestEmail: $guestEmail
				guestCompany: $guestCompany
				guestDepartment: $guestDepartment
				guestPhone: $guestPhone
				guestRoom: $guestRoom
				guestApartmentNumber: $guestApartmentNumber
				guestReservation: $guestReservation
				guestEmployeeCode: $guestEmployeeCode
				guestPosition: $guestPosition
				stripeCustomerId: $stripeCustomerId
				payLater: $payLater
				carType: $carType
				carNotes: $carNotes
				bayId: $bayId
				isVip: $isVip
				vipContactIds: $vipContactIds
			}
		) {
			id
			guestName
		}
	}
`

export const updateBookingMutation = gql`
	mutation updateBooking (
		$installationId: ID!
		$bookingId: ID!
		$rateCardId: ID!
		$plate: String!
		$startDay: String
		$endDay: String
		$staffName:String
		$reason: String

		$guestName: String
		$guestEmail: String
		$guestCompany: String
		$guestDepartment: String
		$guestPhone: String
		$guestRoom: String
		$guestApartmentNumber: String
		$guestReservation: String
		$guestEmployeeCode: String
		$guestPosition: String
		$stripeCustomerId: String
		$status: BookingStatusEnum
		$carType: String
		$carNotes: String
		$isVip: Boolean
		$vipContactIds: [ID!]
	) {
		updateBooking(
			booking: {
				installationId: $installationId
				id: $bookingId
				rateCardId: $rateCardId
				plate: $plate
				startDay: $startDay
				endDay: $endDay
				staffName:$staffName
				reason: $reason
				guestName: $guestName
				guestEmail: $guestEmail
				guestCompany: $guestCompany
				guestDepartment: $guestDepartment
				guestPhone: $guestPhone
				guestRoom: $guestRoom
				guestApartmentNumber: $guestApartmentNumber
				guestReservation: $guestReservation
				guestEmployeeCode: $guestEmployeeCode
				guestPosition: $guestPosition
				stripeCustomerId: $stripeCustomerId
				status: $status
				carType: $carType
				carNotes: $carNotes
				isVip: $isVip
				vipContactIds: $vipContactIds
			}
		) {
			id
		}
	}
`

export const createEmailMutation = gql`
	mutation createEmail (
		$relatedId: ID!,
		$templateClass: String,
		$settingsJson: EmailSettings
	) {
		createEmail(
			email: {
				relatedId: $relatedId
				templateClass: $templateClass
				settingsJson: $settingsJson
			}
		) {
			id
		}
	}
`

export const openGateMutation = gql`
	 mutation GateControl ($id: ID!, $reason: String!) {
        openGate(gateId: $id, reason: $reason) {
              updatedAt
              flag
        }
    }
`

export const createRefundMutation = gql`
	mutation createRefund (
		$bookingId: ID!,
		$installationId: ID!,
		$amountAud: String!,
		$notes: String
	) {
		createRefund(
			refund: {
				bookingId: $bookingId
				installationId: $installationId
				amountAud: $amountAud
				notes: $notes
			}
		) {
			id
			bookingId
			amountAud
			status
		}
	}
`

export const createCancellationRequestMutation = gql`
	mutation createCancellationRequest($relatedBookingId: ID!, $notes: String) {
		createCancellationRequest(cancellationRequest: { relatedBookingId: $relatedBookingId, notes: $notes }) {
			id
			relatedBookingId
		}
	}
`

export const deleteBookingMutation = gql`
	mutation deleteBooking($bookingId:ID!){
		deleteBooking(bookingId:$bookingId)
	}
`

export const restartQuestTerminal = gql`
	mutation updateGateQuestTerminalStatus($gateId: ID!) {
		updateGateQuestTerminalStatus(gateId: $gateId) {
			id
		}
	}
`

export const updateSign = gql`
	mutation UpdateSign($id: ID!, $input: UpdateSignInput!) {
		updateSign(id: $id, input: $input) {
			id
		}
	}
`

export const cancelChargeV2 = gql`
		mutation CancelChargeV2($id: ID!) {
				cancelChargeV2(id: $id)
		}
`

export const staffBollardOverrideMutation = gql`
	mutation StaffBollardOverride(
		$bayId: ID!
		$action: BollardAction!
		$reason: OverrideReason!
	) {
		staffBollardOverride(bayId: $bayId, action: $action, reason: $reason) {
			outcome
			bayLabel
		}
	}
`
